import {types} from "mobx-state-tree";
import { values } from 'mobx';

export const othersIdea = types.model({
    text: types.string,
    id: types.string,
    seen: types.optional(types.boolean,false),
}).actions(self=>({
    markSeen(){
        self.seen = true;
    }
}))

export const othersIdeaList = types.model({
    ideas : types.optional(types.array(othersIdea),[]),
}).actions(self=>({
    addOthersIdeas(newData){
        newData.forEach(item =>{
            self.ideas.push(item);
        })
    },
})).views(self => ({
    numberOfUnseenChildren() {
        return self.ideas.filter(idea => idea.seen = false).length
    },
    oilLength() {
        return values(self.ideas).length
    },
}));